import _ from "lodash";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Player } from 'patchwork-player';

import * as StorySelectors from "Data/stories/StorySelectors";
import * as SlideSelectors from "Data/slides/SlideSelectors";

import Middle from "Components/Middle";
import Playlist from "Components/Playlist";

class ProjectController extends React.Component
{
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        project: PropTypes.object.isRequired,
        stories: PropTypes.array.isRequired,

        story: PropTypes.object,
        storyId: PropTypes.string,
    };

    render()
    {
        if (this.props.loading) {
            return null; // replace with skeleton?
        }

        if ( ! this.props.project) {
            return <p>null</p>;
        }

        if ( ! this.props.storyId) {
            const [ firstStory ] = this.props.stories;

            if (firstStory) {
                // select the first by default..
                return <Redirect to={`/projects/${this.props.project.id}/${firstStory.id}`} />;
            }
        }

        const orderedSlides = _.orderBy(this.props.slides, [slide => slide.position], ['asc']);
        // NEW:: Embed the Elements into the slides
        const orderedSlidesWithElements = _.map(orderedSlides, slide => ({
            ...slide,
            elements: this.props.getElements(slide.id)
        }));

        return <div className='flex w-full h-full' style={{background: 'radial-gradient(ellipse at center, #444444 0%,#222222 100%)'}}>

            <div className='w-64'>
                <Playlist
                    project={this.props.project}
                    stories={this.props.stories}
                />
            </div>

            <div className='flex flex-grow'>
                {
                    this.props.story && <Middle>
                        <Player slides={orderedSlidesWithElements} />
                    </Middle>
                }
            </div>
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    stories: StorySelectors.filterByProjectId(state, ownProps.project.id),
    story: StorySelectors.findById(state, ownProps.storyId),
    slides: SlideSelectors.filterByStoryId(state, ownProps.storyId),
    getElements: slideId => {
        // map over the elements
        const elements = _.map(state.elements, element => {

            // if we have an image element
            if (element.type === 'image') {

                // find the media item it uses
                const media = _.find(state.media, ['id', element.data.media_id])

                return {
                    ...element,
                    data: {
                        ...element.data,
                        src: media ? media.filename : null              // and add the filename as element.data.src
                    }
                }
            }

            return element;
        });
        return _.filter(elements, ['slide_id', slideId])
    }
});

export default connect(mapStateToProps)(ProjectController);
